<template>
  <div class="mb-5 text-center">
    <div class="small-container pb-5">
      <div class="mb-3 text-left">
        <hl-H1>Send til leietaker for signering</hl-H1>
        <p>
          Kontoavtalen er nå klar for å sendes til {{ depAccount.tenant.fullName }} for gjennomlesning og signering med
          BankID.
        </p>
      </div>

      <div class="mt-5 text-left">
        <div class="bg-light">
          <h5 class="pl-4 pt-5 pb-3">Vennligst noter følgende:</h5>
          <ul class="pl-5 pr-5 pb-5">
            <li>Om leietaker ikke har BankID vil det ikke være mulig å opprette depositumskonto via Husleie.no</li>
            <li>
              Om du bestilte at leieforholdet skal forvaltes vil du motta en bekreftelse på det per e-post, samt at
              leietaker også vil informeres per e-post
            </li>
          </ul>
        </div>
      </div>

      <div class="mt-5 mb-5 text-right">
        <button class="btn btn-primary" @click="sendForSigning" data-cy="send-for-signing-button">
          <hl-LoaderDots v-if="isAPICallLoading" variant="white"></hl-LoaderDots>
          <span v-else>Send til leietaker</span>
        </button>
      </div>
    </div>

    <hl-NextBackBottomBar
      buttonSize="lg"
      backText="tilbake"
      :backLink="getBackLink"
      @validateAll="$validator.validateAll()"
      :displayNext="false"
    />
  </div>
</template>

<style scoped lang="scss"></style>

<script>
import { mapGetters } from 'vuex';
import NextBackBottomBar from '@/components/NextBackBottomBar.vue';
import H1 from '@modules/husleie-framework/src/components/headings/H1.vue';
import LoaderDots from '@modules/husleie-framework/src/components/loaders/LoaderDots.vue';
import hlValidateBeforeLeave from '@modules/husleie-framework/src/mixins/hlValidateBeforeLeave';

export default {
  mixins: [hlValidateBeforeLeave],
  props: {
    depAccount: Object,
    contract_id: String,
    contract_status: String,
    isAPICallLoading: Boolean,
  },
  components: {
    'hl-H1': H1,
    'hl-LoaderDots': LoaderDots,
    'hl-NextBackBottomBar': NextBackBottomBar,
  },
  data() {
    return {
      download_link: '',
    };
  },

  mounted() {
    /* GTM Tracking */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'VirtualPageview',
      virtualPageURL: '/depositaccount/step5/send-to-tenant',
      virtualPageTitle: 'Deposit Account | Step 5 | Send to Tenant',
    });
  },

  updated() {
    this.$emit('updated');
  },

  computed: {
    ...mapGetters('common/features', ['getFeature']),
    getBackLink() {
      const isPlanDisabled = this.getFeature('tenancySubscripition').isDisabled;
      if (this.depAccount.upsale.rentadm.plan === 'none' && !isPlanDisabled && !this.depAccount.hasSubscription) {
        return 'plan';
      } else if (isPlanDisabled || this.depAccount.hasSubscription) {
        return 'deposit';
      } else {
        return 'rentAdm';
      }
    },
  },

  methods: {
    sendForSigning() {
      this.$emit('sentForSigning');

      /* GTM Tracking */
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'VirtualPageview',
        virtualPageURL: '/depositaccount/step6/completed',
        virtualPageTitle: 'Deposit Account | Step 6 | Completed',
        administration: this.isSubscriptionBasic
          ? 'basic'
          : this.isSubscriptionPremium
          ? 'premium'
          : this.isSubscriptionPro
          ? 'business'
          : 'none',
        landlordType: this.depAccount.landlord.type,
        monthsOfDeposit: this.depAccount.deposit.ownDefined ? 'selfDefined' : this.depAccount.deposit.months,
      });
    },
  },
};
</script>
